import Image from "next/image";
import Link from "next/link";
import Plant from "../../../public/images/plant.jpg";
import PromotingPositiveMedia from "../../../public/about/promoting-positive-media.jpg";
import BuildingPartnerships from "../../../public/about/building-partnerships.jpg";
import ReducingMisinformation from "../../../public/about/reducing-misinformation.jpg";
import MakingSocialImpact from "../../../public/about/making-social-impact.jpg";
import ActingNow from "../../../public/about/acting-now.jpg";

import { poppins } from "config/fonts";

const commitmentImages = [
  {
    source: PromotingPositiveMedia,
    alt: "Promoting positive media",
    title: "Promoting positive media",
  },
  {
    source: BuildingPartnerships,
    alt: "Building partnerships",
    title: "Building partnerships",
  },
  {
    source: ReducingMisinformation,
    alt: "Reducing misinformation",
    title: "Reducing misinformation",
  },
  {
    source: MakingSocialImpact,
    alt: "Making social impact",
    title: "Making social impact",
  },
  { source: ActingNow, alt: "Acting now", title: "Acting now" },
];

function Vision() {
  return (
    <div className="relative isolate mb-[69px] mt-[20px] overflow-visible bg-transparent pb-40 pt-2 sm:pt-8">
      <div
        className={`${poppins.className} mx-auto flex max-w-5xl flex-col justify-center px-5 text-center`}
      >
        <h1 className={`mt-14 text-[4vw] font-normal sm:text-2xl`}>
          <span className="inline max-w-sm ">
            Our mission is{" "}
            <span className="inline max-w-sm">to provide a platform </span>
          </span>{" "}
          <span className="block lg:inline">
            for <span className="text-blue-600">publishers</span> and{" "}
            <span className="inline text-yellow-600">charities</span> to{" "}
          </span>
          <span className="block text-emerald-600">
            create actionable content.
          </span>
        </h1>
        <Image
          className="mt-16 opacity-90 sm:mt-28"
          src={Plant}
          alt="Planting the future"
          width={2244}
          height={1672}
          priority
        />
        <h4 className="mt-10 text-[4vw] font-normal sm:text-2xl">
          From donation buttons to audience polls,{" "}
          <span className="block">
            discover how actionable content can help your business.
          </span>
        </h4>
        {/*
        <a className="pointer-cursor mt-8 text-emerald-600 hover:underline" href="/actionable-content#filter=top">
          Learn more
        </a>

        <h3 className="">
          Make your content actionable with a button
        </h3> */}
        <div className="mt-14 flex w-full justify-center">
          <Link
            href="/search/Climate+change"
            className="text-md flex w-fit justify-center rounded-md border border-transparent bg-emerald-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-emerald-600 disabled:opacity-70"
          >
            Discover Donate Buttons
          </Link>
        </div>
        {/* <a href="/actions">Discover Content</a> */}
        {/* Top actionable content */}
        <h3 className="mt-32 text-[5vw] font-normal sm:mt-40 sm:text-4xl">
          Committed to helping steer the{" "}
          <span className="block">media in a positive direction</span>
        </h3>
        <div className="mt-14 flex w-full justify-center">
          <h4 className="mt-10 text-[4vw] font-normal sm:text-2xl">
            Our commitments
          </h4>
          {/* <a
            href="/commitments"
            className="text-md flex w-fit justify-center rounded-md border border-transparent bg-emerald-600 py-2 px-4 font-medium text-white shadow-sm hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-emerald-600 disabled:opacity-70"
          >
            Our commitments
          </a> */}
        </div>

        <ul
          role="list"
          className="mt-14 flex flex-row flex-wrap justify-center gap-x-10 gap-y-10"
        >
          {commitmentImages.map((file) => (
            <li
              key={file.alt}
              className="relative box-content w-[calc(33.33%-2.5rem)]"
            >
              <div className="aspect-h-7 aspect-w-10 group block overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100">
                <Image
                  src={file.source}
                  alt={file.alt}
                  placeholder="blur"
                  className="pointer-events-none object-cover group-hover:opacity-75"
                />
              </div>
              <h5 className="pointer-events-none mt-4 block text-[3vw] font-normal sm:text-xl">
                {file.title}
              </h5>
            </li>
          ))}
        </ul>
        {/* committments */}
        {/* Published actionable content making an impact*/}
        {/* Explore actionable content*/}

        <div className="mt-20 flex w-full justify-center">
          <Link
            href="/search/Climate+change"
            className="text-md flex w-fit justify-center rounded-md border border-transparent bg-emerald-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-emerald-600 disabled:opacity-70"
          >
            Discover Act Now Buttons
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Vision;
